import React from 'react'

import ArticleWrapper from '../../../react4xp/components/ArticleWrapper'

function ArticleLayout({ title, date, intro, cta, image, imageMedium, text }) {
  return (
    <ArticleWrapper
      date={date}
      title={title}
      intro={intro}
      featuredImage={{
        src: image.link,
        srcMobile: imageMedium.link,
        alt: image.alt,
        caption: image.caption
      }}
      content={text}
      primaryButton={(cta.style === 'button') ? {
        text: cta.text,
        href: cta.href,
        external: cta.external
      } : undefined}
      secondaryButton={(cta.style === 'link') ? {
        text: cta.text,
        href: cta.href,
        external: cta.external
      } : undefined}
    />
  )
}

export default (props) => <ArticleLayout {...props} />
